import ReactSwitch from "react-switch";

import { useTheme } from "@hooks";
import { SwitchProps } from "./types";

export const Switch = ({ checked, onChange }: SwitchProps) => {
  const { theme } = useTheme();

  return (
    <ReactSwitch
      onChange={onChange}
      checked={checked}
      uncheckedIcon={false}
      checkedIcon={false}
      height={20}
      width={34}
      onColor={theme.switch.background}
    />
  );
};
